function initMediaVideos() {
    document.querySelectorAll('.media_full .media_video_play').forEach(button => {
        const video = document.getElementById(button.getAttribute('aria-controls'));
        if (!video) return;

        video.controls = false;
        button.hidden = false;

        video.addEventListener('playing', () => {
            video.controls = true;
            button.hidden = true;
            if (document.activeElement === button) video.focus();
        }, { once: true });

        button.addEventListener('click', async () => {
            button.disabled = true;
            try {
                await video.play();
            } catch {
                // Keep the start button available if playback fails.
                button.disabled = false;
            }
        });
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMediaVideos, { once: true });
} else {
    initMediaVideos();
}
